const MandatairesSubNavigationStyle = {
  justifyContent: "space-between",
  px: 1,
  width: "100%",
};

export { MandatairesSubNavigationStyle };
